import { useEffect, useState } from "react";

const isDomReady = () =>
  typeof document !== "undefined" &&
  (document.readyState === "interactive" || document.readyState === "complete");

export function useWindowLoad() {
  const [isLoaded, setIsLoaded] = useState(isDomReady());

  useEffect(() => {
    if (isDomReady()) {
      setIsLoaded(true);
      return;
    }

    const markLoaded = () => setIsLoaded(true);

    const handleReadyStateChange = () => {
      if (isDomReady()) {
        markLoaded();
      }
    };

    document.addEventListener("readystatechange", handleReadyStateChange);
    window.addEventListener("DOMContentLoaded", handleReadyStateChange);
    window.addEventListener("load", handleReadyStateChange);

    const rafId = window.requestAnimationFrame(markLoaded);

    return () => {
      document.removeEventListener("readystatechange", handleReadyStateChange);
      window.removeEventListener("DOMContentLoaded", handleReadyStateChange);
      window.removeEventListener("load", handleReadyStateChange);
      window.cancelAnimationFrame(rafId);
    };
  }, []);

  return isLoaded;
}
